import { BrandStrategy } from '../types';

export const hasBrandStrategyContent = (strategy: BrandStrategy) => {
  return Boolean(
    strategy.purpose ||
      strategy.mission ||
      strategy.vision ||
      strategy.why_customers_choose_you ||
      strategy.why_customers_do_not_choose_you ||
      strategy.why_start_the_business ||
      strategy.unique_industry_perspective ||
      strategy.proudest_moment_in_business
  );
};
